import React, { useEffect } from 'react';
import { useNavigate, To } from 'react-router-dom-v5-compat';
import { useAnalytics } from '~/domain/analytics/hooks/use-analytics';

interface Props {
  tracking: {
    category?: string;
    action?: string;
    label: string;
  };
  to: To;
  push?: boolean;
}

const TrackingRedirect: React.FC<Props> = ({ tracking, to, push }) => {
  const { triggerGAEvent } = useAnalytics();
  const navigate = useNavigate();

  useEffect(() => {
    triggerGAEvent({
      category: 'Redirect',
      action: 'Redirect',
      ...tracking,
    });
    navigate(to, { replace: !push });
  }, []);

  return null;
};

export default TrackingRedirect;
